import React, { useEffect, useState } from "react";
import $ from "jquery";
import LocationHeading from "../../../shared/LocationHeading";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { MdCheck } from "react-icons/md";
import Loading from "../../../shared/Loading";
import pdfImage from "../../../assets/Images/pdfimg.png";
import userImg from "../../../assets/Images/Vector.png";
import email from "../../../assets/Images/email.png";
import post from "../../../assets/Images/post.png";
import address from "../../../assets/Images/entypo_address.png";
import phone from "../../../assets/Images/phone.png";
import { toast } from "react-toastify";
import { useUserContext } from "../../../components/context/UserContext";
import client from "../../../services/Client";
import DocumentModal from "../../../shared/DocumentModal";
import LocationSuccessModal from "../../../shared/LocationSuccessModal";

$(".selectable-img").on("click", function (event) {
  event.preventDefault();
  $(".selectable-img li").removeClass("selected");
  $(this).parent().addClass("selected");
  var imageUrl = $(this).find("img").attr("src");
  $(".view-img img").attr("src", imageUrl);
});

function OrderDetails() {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("Buyer 1");
  const [orderToComplete, setOrderToComplete] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [completeLoading, setCompleteLoading] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [uploadedPdfUrls, setUploadedPdfUrls] = useState([]);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false);
  const { state } = useUserContext();
  const pathname = useLocation().pathname;

  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    // setIsLoading(true);
  };

  // Handle the Go Back button click
  const handleGoBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const token = state.token;

  const fetchOrderDetails = async () => {
    try {
      setIsLoading(true);
      const response = await client.get(`admin/get-order/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const orderData = response.data.data;
      setOrderDetail(orderData);
      console.log("order data :", orderData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching order details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

  const showNoDocumentsErrorToast = () => {
    toast.error("Please upload at least one document.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  };

  const uploadDocuments = () => {
    setShowDocsModal(true);
    setShowOverlay(true);
    handleSaveDocuments();
  };

  const handleSaveDocuments = async () => {
    try {
      setIsLoading(true);
      if (uploadedFiles.length === 0) {
        showNoDocumentsErrorToast();
        setIsLoading(false);
        setShowOverlay(false);
        return;
      }
      // Create a form data object to send files
      const formData = new FormData();
      uploadedFiles.forEach((file, index) => {
        formData.append("documents", file);
      });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // Required for file uploads
        },
      };
      const response = await client.post(
        `admin/add-documents/${id}`,
        formData,
        config
      );
      const updatedDocumentData = response.data.data;

      setShowDocsModal(false);
      setIsSuccessModalOpen(true);
      setShowOverlay(false);
      setUploadedPdfUrls(updatedDocumentData);
      fetchOrderDetails();
      setUploadedFiles([]);
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving documents:", error);
    }
  };

  const cancelDelete = () => {
    setShowDocsModal(false);
    setShowCompleteModal(false);
    setShowOverlay(false);
  };

  const showOrderCompleteToast = () => {
    toast.success("Order marked as complete.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  };

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
    setIsOverlayVisible(false);
    document.body.classList.remove("no-scroll");
    // navigate(`/order/detail${id}`);
  };

  const confirmComplete = async () => {
    setCompleteLoading(true);

    try {
      const response = await client.post(
        `admin/mark-as-complete?orderNumber=${orderDetail.orderNumber}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate(-1);
      // showOrderCompleteToast();
    } catch (error) {
      console.error("Error Completing Order:", error);
      toast.error(error?.message);
      setCompleteLoading(false);
      // setShowOverlay(false);
    } finally {
      setCompleteLoading(false);
    }
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    const newFiles = Array.from(files);
    setUploadedFiles([...uploadedFiles, ...newFiles]);
  };

  const renderFiles = () => {
    return (
      <div className="pdf-document">
        {uploadedFiles.map((file, index) => (
          <div className="pdf-file" key={index}>
            {file.type === "application/pdf" ? (
              <img style={{ width: "50px" }} src={pdfImage} alt="pdf" />
            ) : (
              <img src={URL.createObjectURL(file)} alt={file.name} />
            )}
            <span>
              {file.type === "application/pdf"
                ? file.name.slice(-20)
                : file.name}
            </span>
          </div>
        ))}
      </div>
    );
  };

  const getInitials = (firstName, lastName) => {
    const initials = `${firstName.charAt(0)}${lastName.charAt(
      0
    )}`.toUpperCase();
    return initials;
  };

  if (isLoading) {
    return (
      <div className="overlay">
        <Loading />
      </div>
    );
  }

  return (
    <div className="location_list">
      {showOverlay && <div className="overlay"></div>}
      <LocationHeading
        title={[
          <Link onClick={handleGoBack}>
            <i
              style={{
                color: "#000",
                fontSize: "16px",
                marginBottom: "10px",
              }}
              className="fa fa-long-arrow-left me-2"
              aria-hidden="true"
            ></i>
          </Link>,
          pathname.startsWith("/lockedPlots/LockedPlotDetails/")
            ? "Locked Plot Detail"
            : "Order Detail",
        ]}
      />

      <Container fluid>
        <div style={{ maxWidth: "1920px" }}>
          <div className="order-details-head">
            <h4>
              Total: <span>£{orderDetail?.price}</span>
            </h4>
            <button
              onClick={() => confirmComplete()}
              className="user-edit-button"
              disabled={completeLoading}
            >
              {completeLoading ? "Completing..." : "Mark as Complete"}
            </button>
          </div>

          <Row>
            <Col lg="9">
              {/* ✅ Product Details */}
              {orderDetail?.plotProduct.map((product, index) => (
                <div
                  key={index}
                  className="blog-info-main p-2 me-2 bg-transparent mb-0"
                >
                  <Row className="bg-white p-4 mb-4">
                    <Col lg="4">
                      <div className="details-img">
                        <div className="view-img">
                          <div className="main_image">
                            <img src={product.plots[0]?.images[0]} alt="" />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg="8">
                      <div className="location-details-main order-info-main">
                        <div className="about-location">
                          <div className="about-location-head">
                            <div className="about-heading">
                              <h3 className="d-flex align-items-center">
                                {product.siteName}
                                {orderDetail.documentation.status ? null : (
                                  <button className="available pending-order ms-1">
                                    Pending
                                  </button>
                                )}
                              </h3>
                              <span>
                                <b>Order ID</b>: {orderDetail.orderNumber}
                              </span>
                              <span className="mx-2 dot_span"></span>
                              <span>
                                <b> Created on:</b>{" "}
                                {new Date(orderDetail.createdAt)
                                  .toLocaleString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                  })
                                  .replace("at", " ")}
                              </span>
                            </div>
                          </div>

                          <div className="about-category d-flex mt-4">
                            <div className="me-5">
                              <h6>
                                <b>Category</b>
                              </h6>
                              <span>
                                {product.type === "Single Plot"
                                  ? product.category.slice(0, -1)
                                  : product.category}
                              </span>
                            </div>
                            <div className="ms-5">
                              <h6>
                                <b>Product Type</b>
                              </h6>
                              <span>{product.type}</span>
                            </div>
                            <div className="ms-5">
                              <h6>
                                <b>Plot Type</b>
                              </h6>
                              <span>{product.type}</span>
                            </div>
                          </div>

                          <div className="about-price order-price">
                            <span>£{product.totalPrice}</span>
                          </div>

                          <div className="about-discription mt-4">
                            <h4>
                              <b>Description</b>
                            </h4>
                            <p className="text-muted">
                              {product.plots[0]?.description}
                            </p>
                          </div>

                          <div className="about-sizes">
                            <ul>
                              <li>
                                <p>Plot Size</p>
                                {product.plots[0]?.plotSize}
                              </li>
                              <li>
                                <p>Plot Number</p>
                                <div className="details-plot-number">
                                  {product.plots.map((plot, i) => (
                                    <span className="plot-number me-2" key={i}>
                                      {plot.plotNumber}
                                    </span>
                                  ))}
                                </div>
                              </li>
                              <li>
                                <p>Phase</p>
                                {product.plots[0]?.phase}
                              </li>
                              <li>
                                <p>Subphase</p>
                                {product.plots[0]?.subPhase}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* ✅ Additional Items */}
              {orderDetail?.additionalItemProduct?.map(
                (additionalItem, index) => (
                  <Row key={index} className="mt-5">
                    <Col lg="3">
                      <div className="details-img">
                        <div className="view-img">
                          <div className="main_image">
                            <img
                              src={additionalItem.images[selectedImageIndex]}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="selectable-img">
                          <ul>
                            {additionalItem.images.map((image, idx) => (
                              <li
                                key={idx}
                                className={
                                  idx === selectedImageIndex ? "selected" : ""
                                }
                                onClick={() => setSelectedImageIndex(idx)}
                              >
                                <img src={image} alt={`Location ${idx + 1}`} />
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="location-details-main order-info-main">
                        <div className="about-location">
                          <div className="about-location-head">
                            <div className="about-heading">
                              <h3 className="d-flex align-items-center">
                                {additionalItem.title}
                              </h3>
                              <span>
                                <b>Order ID</b>: {orderDetail.orderNumber}
                              </span>
                              <span className="circle"></span>
                              <span>
                                <b> Created on:</b>{" "}
                                {new Date(orderDetail.createdAt)
                                  .toLocaleString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                  })
                                  .replace("at", " ")}
                              </span>
                            </div>
                          </div>
                          <div className="about-price order-price">
                            <span>£{additionalItem.price}</span>
                          </div>
                          <div className="about-discription order-discription">
                            <p className="p-spacing">
                              {additionalItem.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )
              )}
            </Col>

            {/* ✅ Customer Info (only once) */}
            <Col lg="3">
              <div className="customer-order bg-white p-4">
                <div className="customer-details bg-transparent">
                  <h2 className="mb-4">Customer info</h2>
                  <div className="customer-profile">
                    <div className="customer-img mb-4">
                      {orderDetail.user.image ? (
                        <img src={orderDetail.user.image} alt="agent" />
                      ) : (
                        <div className="placeholder-name_user">
                          {getInitials(
                            orderDetail.user.firstName,
                            orderDetail.user.lastName
                          )}
                        </div>
                      )}
                      <div className="customer-name">
                        <span>{orderDetail.user.name}</span>
                        <p>
                          <b>Registered on:</b>{" "}
                          {new Intl.DateTimeFormat("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          })
                            .format(new Date(orderDetail.user.createdAt))
                            .replace("at", "")}
                        </p>
                      </div>
                    </div>

                    <div className="customer-contact">
                      <span>Contact info</span>
                      <ul>
                        <li>
                          <i className="fa fa-envelope-o me-2"></i>
                          {orderDetail.user.email}
                        </li>
                        <li>
                          <i className="fa fa-phone me-2"></i>
                          {orderDetail.user.phoneNumber.dialCode}-
                          {orderDetail.user.phoneNumber.number}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="buyer-details">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      {orderDetail?.buyerAddress?.map((buyer, index) => (
                        <li
                          key={index}
                          className={
                            activeTab === `Buyer ${index + 1}`
                              ? "buyer-button"
                              : "buyer-button-one"
                          }
                          onClick={() => handleTabClick(`Buyer ${index + 1}`)}
                        >
                          {buyer.type}
                        </li>
                      ))}
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      {orderDetail?.buyerAddress.map((buyer, index) => (
                        <div
                          key={index}
                          style={{ background: "#ffffff", color: "black" }}
                          className={`tab-pane fade ${
                            activeTab === `Buyer ${index + 1}`
                              ? "show active"
                              : ""
                          }`}
                        >
                          <div className="buyer-info">
                            <ul style={{ display: "inline", color: "#000" }}>
                              <li>
                                <img src={userImg} alt="" className="me-2" />
                                {buyer.firstName} {buyer.lastName}
                              </li>
                              <li>
                                <img src={post} alt="" className="me-2" />
                                {buyer.postalCode}
                              </li>
                              {buyer.address && (
                                <li>
                                  <img src={address} alt="" className="me-2" />
                                  {buyer.address}
                                </li>
                              )}
                              <li>
                                <img src={email} alt="" className="me-2" />
                                {buyer.email}
                              </li>
                              <li>
                                <img src={phone} alt="" className="me-2" />
                                {buyer.contactNumber.dialCode}{" "}
                                {buyer.contactNumber.number}
                              </li>
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      {/* {showCompleteModal && <div className="overlay"></div>}
      <DocumentModal
        isOpen={showCompleteModal}
        onClose={cancelDelete}
        SuccessMessage="Please confirm!"
        ModalMessage="Are you sure all the document process has been completed?"
        onConfirmSave={() => confirmComplete(orderToComplete.id)}
      />
      {isSuccessModalOpen && <div className="overlay"></div>}
      <LocationSuccessModal
        isOpen={isSuccessModalOpen}
        onClose={closeSuccessModal}
        SuccessMessage={"Success!"}
        ModalMessage={"Your Documents has been updated successfully"}
      /> */}
    </div>
  );
}

export default OrderDetails;
